import React from 'react';
import parse from 'html-react-parser';
import { marked, type Renderer } from 'marked';

import './styles.scss';

interface MarkdownDisplayProps {
  markdownText: string;
}

function isAbsoluteURL(url: string): boolean {
  return /^(https?|http):\/\//i.test(url);
}

const MarkdownDisplay: React.FC<MarkdownDisplayProps> = ({ markdownText }) => {
  if (!markdownText) return null;

  const customRenderer: Partial<Renderer> = {
    link(this: Renderer, linkObj) {
      const { href = '', title, text } = linkObj;
      const safeHref = isAbsoluteURL(href) ? href : `https://${href}`;
      const titleAttr = title ? ` title="${title}"` : '';
      return `<a href="${safeHref}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
    },
  };

  marked.use({ renderer: customRenderer });

  const html = marked.parse(markdownText) as string;

  return <div className="markdown">{parse(html)}</div>;
};

export default MarkdownDisplay;
